import React, { useEffect, useContext, useReducer, useState } from "react";
import reducer from "../reducers/filter_reducer";
import {
  LOAD_PRODUCTS,
  SET_GRIDVIEW,
  SET_LISTVIEW,
  UPDATE_SORT,
  SEARCH_SORT,
  SORT_PRODUCTS,
  UPDATE_FILTERS,
  FILTER_PRODUCTS,
  CLEAR_FILTERS,
  REMOVE_FILTER, // New action type
} from "../reducers/actions";
import { ProductContext } from "./products_context";
import PropTypes from "prop-types";

const initialState = {
  filtered_products: [],
  all_products: [],
  grid_view: true,
  sort: "price-lowest",
  filters: {
    text: "",
    specialities: [],
    categories: [],
    min_price: 0,
    max_price: 0,
    price: 0,
    premium: false,
    ownerName: "",
    ownerId: "",
  },
  selectedFilters: [], // New array to store active filters
};

const FilterContext = React.createContext();

export const FilterProvider = ({ children }) => {
  FilterProvider.propTypes = {
    children: PropTypes.any.isRequired, // Replace `object` with the correct type
  };
  const [isList, setIsList] = useState(true);
  const products = useContext(ProductContext);
  const [state, dispatch] = useReducer(reducer, initialState);

  useEffect(() => {
    dispatch({ type: LOAD_PRODUCTS, payload: products });
  }, [products]);

  useEffect(() => {
    dispatch({ type: FILTER_PRODUCTS });
    dispatch({ type: SORT_PRODUCTS });
  }, [products, state.sort, state.filters]);

  const setGridView = () => {
    dispatch({ type: SET_GRIDVIEW });
  };

  const setListView = () => {
    dispatch({ type: SET_LISTVIEW });
  };

  const updateSort = (e) => {
    const value = e.target.value;
    dispatch({ type: UPDATE_SORT, payload: value });
  };

  const searchParam = (e) => {
    const value = e.target.value;
    dispatch({ type: SEARCH_SORT, payload: value });
  };

  const updateFilters = (e) => {
    let value = e.target.value;
    let name = e.target.name;

    // if (name === "price") {
    //   value = Number(value);
    // }
    if (name === "price" && !Array.isArray(value)) {
      value = Number(value);
    }

    if (name === "premium") {
      value = e.target.checked;
    }

    dispatch({ type: UPDATE_FILTERS, payload: { name, value } });
  };

  const removeFilter = (filterName) => {
    dispatch({ type: REMOVE_FILTER, payload: filterName });
  };

  const clearFilters = () => {
    dispatch({ type: CLEAR_FILTERS, payload: products });
  };

  // Calculate active filters
  const activeFilters = Object.keys(state.filters).filter(
    (key) =>
      (key === "text" && state.filters[key] !== "") ||
      (key === "specialities" && state.filters[key] !== "All") ||
      (key === "categories" && state.filters[key] !== "All") ||
      (key === "price" && state.filters[key] !== state.filters.max_price) ||
      (key === "premium" && state.filters[key] !== false) ||
      (key === "ownerName" && state.filters[key] !== "") ||
      (key === "ownerId" && state.filters[key] !== "")
  );

  return (
    <FilterContext.Provider
      value={{
        ...state,
        setGridView,
        setListView,
        updateSort,
        updateFilters,
        clearFilters,
        removeFilter,
        searchParam,
        isList,
        setIsList,
        activeFilters, // Exporting activeFilters
      }}
    >
      {children}
    </FilterContext.Provider>
  );
};

export const useFilterContext = () => {
  return useContext(FilterContext);
};
